"use client"

import { useState } from "react"
import styles from "./FAQ.module.css"
import faqImg from "../../assets/images/Rhinoplasty-2.png"

/*
 * Sol tarafta görüntü ve açıklama, sağ tarafta genişletilebilir SSS soruları
 * @param {Object} leftSection - Sol bölüm verileri (başlık, açıklama, görüntü)
 * @param {Array} faqs - SSS öğeleri dizisi (soru ve cevap)
 */
export default function FAQ({
  leftSection = {
    title: "Have questions?",
    description: "Browse common questions or contact us for tailored advice.",
    image: faqImg
  },
  faqs = []
}) {
  // Açık olan SSS öğesinin indeksi (başlangıçta tümü kapalı)
  const [openIndex, setOpenIndex] = useState(null)

  // SSS öğesini aç/kapat fonksiyonu
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.contentGrid}>
          {/* Sol Bölüm - Mavi Arka Plan */}
          <div className={styles.leftSection}>
            <div className={styles.imageContainer}>
              <img 
                src={leftSection.image} 
                alt="Hair Treatment"
                className={styles.image}
              />
            </div>
            <div className={styles.textContainer}>
              <h2 className={styles.title}>{leftSection.title}</h2>
              <p className={styles.description}>{leftSection.description}</p>
            </div>
          </div>

          {/* Sağ Bölüm - SSS Akordeonu */}
          <div className={styles.rightSection}>
            <h2 className={styles.faqTitle}>FAQ</h2>
            {/* Akordeyon listesi */}
            <div className={styles.accordion}>
              {faqs.map((faq, index) => (
                <div key={index} className={styles.faqItem}>
                  {/* SSS sorusu - tıklanabilir düğme */}
                  <button 
                    className={`${styles.faqButton} ${openIndex === index ? styles.active : ''}`}
                    onClick={() => toggleFAQ(index)}
                  >
                    <span className={styles.question}>{faq.question}</span>
                    {/* Artı/eksi simgesi */}
                    <span className={styles.plusIcon}>
                      {openIndex === index ? '−' : '+'}
                    </span>
                  </button>
                  {/* SSS cevabı - açıksa göster */}
                  {openIndex === index && (
                    <div className={styles.answer}>
                      <p>{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
